module.exports = __webpack_public_path__ + "media/images/lesson_5/nini_negativa-c2cab9dc6d25c91ca0518a865a9f5714.png";